import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Toolbar, Typography, Card, CardHeader, CardContent, IconButton, Icon, TextField, MenuItem, Switch } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'
import clsx from 'clsx'
import { KeyboardDatePicker, DatePicker, TimePicker, KeyboardTimePicker } from '@material-ui/pickers'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import BasicInfo from '../../../components/Cards/Facility/BasicInfo'
import Configurations from '../../../components/Cards/Facility/Configurations'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import moment from 'moment'
import { TIME_ZONE_ABBREVIATIONS } from '../../../utils'
import { getApartmentList, updateFacility, reloadFacilities } from '../../../actions/facilities/facilities.actions'
import { showError, showSuccess } from '../../../actions/misc/misc.actions'
const cutoffs = [
  { name: 'The Day Of', number: 0 },
  { name: 'One Day Before', number: 1 },
  { name: 'Two Days Before', number: 2 }
]

const price_ranges = [
  'Minus (-)',
  'Plus (+)'
]

const start_times = [
  '06:00', '06:15', '06:30', '06:45',
  '07:00', '07:15', '07:30', '07:45',
  '08:00', '08:15', '08:30', '08:45',
  '09:00', '09:15', '09:30', '09:45',
  '10:00', '10:15', '10:30', '10:45',
  '11:00', '11:15', '11:30', '11:45',
  '12:00', '12:15', '12:30', '12:45',
  '13:00', '13:15', '13:30', '13:45',
  '14:00', '14:15', '14:30', '14:45',
  '15:00', '15:15', '15:30', '15:45',
  '16:00', '16:15', '16:30', '16:45',
  '17:00', '17:15', '17:30', '17:45',
  '18:00'
]

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    paddingTop: '24px',
    paddingLeft: '25px',
    paddingRight: '20px',
    paddingBottom: '75px'
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    paddingRight: '0px !important'
  },
  grid: {

  },
  groomingRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  gridDouble: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  },
  fieldWrapper: {
    // '& .MuiTextField-root': { width: '100%', minWidth: '100%' }
  },
  header: {
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: .75,
    marginTop: 24,
    marginBottom: 8
  },
  header3: {
    fontSize: 16,
    fontWeight: '800',
    marginTop: 0,
    marginBottom: 16
  },
  header2: {
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: .75,
    marginTop: 24,
    marginBottom: 8
  },
  purple: {
    backgroundColor: '#F0EDFB',
    width: '400px',
    padding: 12,
    paddingTop: 16,
    paddingBottom: 16,
    borderRadius: 10
  },
  purpleText: {
    fontSize: 14,
    lineHeight: '21px',
    color: '#270050',
    padding: 0,
    margin: 0
  },
  switchRoot: {
    width: 51,
    height: 31,
    padding: 0
  },
  switchBase: {
    padding: 0,
    margin: 2,
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#6B4AD6',
        opacity: 1
      },
      '& .far::before': {
        color: '#6B4AD6'
      }
    },
    '&$focusVisible $thumb': {
      color: '#6B4AD6'
      //border: "6px solid #fff",
    }
  },
  thumb: {
    width: 27,
    height: 27,
    background: '#F3F3F3',
    border: '1px solid #E5E5E5',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .far': {
      color: '#A2A1A4',
      fontSize: '13px',
      lineHeight: '15px'
    }
  },
  track: {
    borderRadius: 100,
    padding: 2,
    backgroundColor: '#D0CFD2',
    opacity: 1,
    transition: theme.transitions.create(['background-color'])
  },
  sharingWrapper: {
    height: 56,
    width: 500,
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 6,
    background: '#F9F9F9'
  },
}))

const FacilityBasicInfo = () => {
  const classes = useStyles()
  const params = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const selectedFacility = useSelector((state) => state.specific.facilities.selected)
  const markets = useSelector(state => state.specific.markets.markets)
  const loading = useSelector((state) => state.specific.facilities.loading)
  const [current, setCurrent] = useState(null)
  const [isSaveShown, setIsSaveShown] = useState(false)
  const [startTime, setStartTime] = useState(new Date())
  const [bookingCutoffTime, setBookingCutoffTime] = useState(new Date())
  const [noShowTime, setNoShowTime] = useState(new Date())
  const [type, setType] = useState('daycare')
  const [timeZone, setTimeZone] = useState('')

  useEffect(() => {
    dispatch(reloadFacilities(false))
  }, [])

  useEffect(() => {
    if (location?.pathname?.includes('boarding')) setType('boarding')
    if (location?.pathname?.includes('compatibility')) setType('compatibility')
    if (location?.pathname?.includes('grooming')) setType('grooming')
    if (location?.pathname?.includes('daycare')) setType('daycare')
  }, [location])

  useEffect(() => {
    if (params.facilityId && selectedFacility) {
      setCurrent(cloneDeep(selectedFacility))
    }
  }, [params.facilityId, selectedFacility])

  useEffect(() => {
    if (markets && markets.length && selectedFacility) {
      let market = markets.find(m => m._id === selectedFacility.market_id)
      if (market?.time_zone) {
        let tz = TIME_ZONE_ABBREVIATIONS[market.time_zone]
        if (tz) setTimeZone(tz)
      }
    }
  }, [selectedFacility, markets])

  useEffect(() => {
    if (current && selectedFacility) {
      let facilityEqual = !isEqual(current, selectedFacility)

      setIsSaveShown(facilityEqual)
    }
  }, [current, selectedFacility])

  const saveSelectedFacility = () => {
    try {
      let updates = {
        ...current
      }

      delete updates.kennels
      delete updates.playgroups
      delete updates.addOnTypes
      delete updates.add_on_services
      delete updates.areas
      delete updates.capacity
      delete updates.holidays
      delete updates.inventory
      delete updates.kennel_blocks
      delete updates.kennel_types
      delete updates.playgroup_types
      delete updates.playgroup_ids
      delete updates.time_blocks

      if (updates?.services?.grooming?.price_range_max) updates.services.grooming.price_range_max = onlyNumbers(updates.services.grooming.price_range_max)
      if (updates?.services?.grooming?.price_range_min) updates.services.grooming.price_range_min = onlyNumbers(updates.services.grooming.price_range_min)
      if (updates?.services?.boarding?.deposit_rate) {
        const num = onlyNumbers(updates.services.boarding.deposit_rate)
        if (num > (current.services.boarding.overnights_price_shared / 2)) throw new Error('Boarding deposit cannot exceed 50% of the overnight shared kennel price')
        updates.services.boarding.deposit_rate = num
      }
      dispatch(updateFacility(selectedFacility._id, updates))

    } catch (error) {
      dispatch(showError(error || 'An error occured while updating the selected Facility.'))
    }
  }

  const clearChanges = () => {
    setCurrent(cloneDeep(selectedFacility))
  }

  const getCutoffDate = () => {
    let num = current?.services[type].booking_cutoff_date || 0
    return cutoffs.find(c => c.number === num).name
  }

  const onlyNumbers = (value) => {
    if (!value || value === '0') return value
    const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
    if (onlyNums.length) return onlyNums
    return 0
  }

  const formatNumsToDollars = (value) => {
    if (value !== undefined && value !== null) {
      return `$${(value / 100).toFixed(2)}`
    }
    return '$0'
  }

  return (
    <div>
      {current ? (
        <Container className={classes.root} maxWidth="auto">
          <Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
            Booking
          </Typography>
          <Card style={{ maxWidth: '1245px' }}>
            <CardHeader title={type === 'compatibility' ? 'COMPATIBILITY SESSION BOOKING SETTINGS' : `${type} Appointment Booking Settings`} />
            <CardContent>
              <Typography variant="h5" className={classes.header2}>
                {type === 'grooming' ? "GROOMING" : "APPOINTMENT"} START TIME
              </Typography>
              <div className={classes.gridDouble}>
                <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
                  {
                    type === 'grooming' ? (
                      <TextField
                        variant="filled"
                        select
                        value={
                          current?.services[type].visit_start_time
                        }
                        label="Grooming Start Time"
                        onChange={(e) => {
                          setCurrent({
                            ...current,
                            services: {
                              ...current.services,
                              [type]: {
                                ...current.services[type],
                                visit_start_time: e.target.value
                              }
                            }
                          })
                        }
                        }>
                        {start_times.map((value) => (
                          <MenuItem key={`value${value}`} value={value}>
                            {value}
                          </MenuItem>
                        ))
                        }
                      </TextField>
                    ) : (
                      <KeyboardTimePicker
                        disableFuture
                        InputAdornmentProps={{
                          position: 'end',
                          component: () => (
                            <Typography>{timeZone}</Typography>
                          )
                        }}
                        label="Appointment Start Time"
                        inputVariant="filled"
                        ampm={false}
                        value={current?.services[type]?.visit_start_time ? moment(current?.services[type]?.visit_start_time, 'HH:mm').toDate() : new Date()}
                        onChange={(date) => {
                          if (date) {
                            setCurrent({
                              ...current,
                              services: {
                                ...current.services,
                                [type]: {
                                  ...current.services[type],
                                  visit_start_time: date.format('HH:mm')
                                }
                              }
                            })
                          }
                        }}
                        className={classes.datePicker}
                        rightArrowIcon={
                          <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                        }
                        leftArrowIcon={
                          <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                        }
                        KeyboardButtonProps={{
                          'aria-label': 'Start Date',
                          className: classes.calendarButton
                        }}
                      />

                    )
                  }
                </div>
                <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>

                </div>
              </div>
              <Typography variant="h5" className={classes.header2}>
                BOOKING CUT-OFF TIME
              </Typography>
              <div className={classes.gridDouble}>

                <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>

                  <KeyboardTimePicker
                    disableFuture

                    style={{ marginRight: 16 }}
                    ampm={false}
                    InputAdornmentProps={{
                      position: 'end',
                      component: () => (
                        <Typography>{timeZone}</Typography>
                      )
                    }}
                    label="Booking Cutoff Time"
                    inputVariant="filled"
                    value={current?.services[type]?.booking_cutoff_time ? moment(current?.services[type]?.booking_cutoff_time, 'HH:mm').toDate() : new Date()}
                    onChange={(date) => {
                      if (date) {
                        setCurrent({
                          ...current,
                          services: {
                            ...current.services,
                            [type]: {
                              ...current.services[type],
                              booking_cutoff_time: date.format('HH:mm')
                            }
                          }
                        })
                      }
                    }}
                    className={classes.datePicker}
                    rightArrowIcon={
                      <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                    }
                    leftArrowIcon={
                      <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                    }
                    KeyboardButtonProps={{
                      'aria-label': 'Start Date',
                      className: classes.calendarButton
                    }}
                  />
                </div>
                <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>

                  <TextField
                    variant="filled"
                    select
                    value={
                      current?.services[type].booking_cutoff_date
                    }
                    label="Cutoff Day"
                    onChange={(e) => {
                      setCurrent({
                        ...current,
                        services: {
                          ...current.services,
                          [type]: {
                            ...current.services[type],
                            booking_cutoff_date: e.target.value
                          }
                        }
                      })
                    }
                    }>
                    {cutoffs.map((value) => (
                      <MenuItem key={`value${value.number}`} value={value.number}>
                        {value.name}
                      </MenuItem>
                    ))
                    }
                  </TextField>
                </div>
              </div>
              <Typography variant="h5" className={classes.header2}>
                AUTOMATIC NO-SHOW TIME
              </Typography>
              <div className={classes.gridDouble}>

                <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
                  <KeyboardTimePicker
                    disableFuture
                    style={{ marginRight: 16 }}
                    ampm={false}
                    InputAdornmentProps={{
                      position: 'end',
                      component: () => (
                        <Typography>{timeZone}</Typography>
                      )
                    }}
                    label="Automatic No-Show Time"
                    inputVariant="filled"
                    value={current?.services[type]?.noshow_time ? moment(current?.services[type]?.noshow_time, 'HH:mm').toDate() : new Date()}
                    onChange={(date) => {
                      if (date) {
                        setCurrent({
                          ...current,
                          services: {
                            ...current.services,
                            [type]: {
                              ...current.services[type],
                              noshow_time: date.format('HH:mm')
                            }
                          }
                        })
                      }
                    }}
                    className={classes.datePicker}
                    rightArrowIcon={
                      <ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
                    }
                    leftArrowIcon={
                      <ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
                    }
                    KeyboardButtonProps={{
                      'aria-label': 'Start Date',
                      className: classes.calendarButton
                    }}
                  />
                </div>
              </div>
              {
                type === 'grooming' && (
                  <div className={classes.groomingRow}>
                    <div>
                      <Typography variant="h5" className={classes.header2}>
                        PRICE RANGE MIN
                      </Typography>
                      <div className={classes.gridDouble}>

                        <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
                          <TextField
                            variant="filled"
                            style={{
                              width: 200,
                              minWidth: 200,
                              marginRight: 20
                            }}
                            select
                            value={
                              current?.services[type].price_range_min_type
                            }
                            label="Plus/Minus"
                            onChange={(e) => {
                              setCurrent({
                                ...current,
                                services: {
                                  ...current.services,
                                  [type]: {
                                    ...current.services[type],
                                    price_range_min_type: e.target.value
                                  }
                                }
                              })
                            }
                            }>
                            {price_ranges.map((value) => (
                              <MenuItem key={`value${value}`} value={value}>
                                {value}
                              </MenuItem>
                            ))
                            }
                          </TextField>
                          <TextField
                            variant="filled"
                            style={{
                              width: 200,
                              minWidth: 200,
                              marginRight: 24
                            }}
                            label="Amount"
                            value={
                              formatNumsToDollars(onlyNumbers(current?.services[type].price_range_min))
                            }
                            onChange={(e) => {
                              setCurrent({
                                ...current,
                                services: {
                                  ...current.services,
                                  [type]: {
                                    ...current.services[type],
                                    price_range_min: e.target.value
                                  }
                                }
                              })
                            }
                            } />

                        </div>
                      </div>
                    </div>
                    <div>
                      <Typography variant="h5" className={classes.header2}>
                        PRICE RANGE MAX
                      </Typography>
                      <div className={classes.gridDouble}>

                        <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
                          <TextField
                            variant="filled"
                            style={{
                              width: 200,
                              minWidth: 200,
                              marginRight: 20
                            }}
                            select
                            label="Plus/Minus"
                            value={
                              current?.services[type].price_range_max_type
                            }
                            onChange={(e) => {
                              setCurrent({
                                ...current,
                                services: {
                                  ...current.services,
                                  [type]: {
                                    ...current.services[type],
                                    price_range_max_type: e.target.value
                                  }
                                }
                              })
                            }
                            }>
                            {price_ranges.map((value) => (
                              <MenuItem key={`value${value}`} value={value}>
                                {value}
                              </MenuItem>
                            ))
                            }
                          </TextField>
                          <TextField
                            variant="filled"
                            style={{
                              width: 200,
                              minWidth: 200,
                              marginRight: 24
                            }}
                            label="Amount"
                            value={
                              formatNumsToDollars(onlyNumbers(current?.services[type].price_range_max))
                            }
                            onChange={(e) => {
                              setCurrent({
                                ...current,
                                services: {
                                  ...current.services,
                                  [type]: {
                                    ...current.services[type],
                                    price_range_max: e.target.value
                                  }
                                }
                              })
                            }
                            } />

                        </div>
                      </div>
                    </div>

                  </div>

                )
              }


              <div style={{ marginTop: 48 }}>
                <Typography variant="h5" className={classes.header}>
                  PREVIEW CUT-OFF TEXT
                </Typography>
                <div className={classes.purple}>
                  <Typography variant="body2" className={classes.purpleText}>
                    The last minute booking window ends at {moment(current?.services[type]?.booking_cutoff_time, 'HH:mm').format('h:mm a')} {getCutoffDate().toLowerCase()} the appointment start date. If you need to book a last minute appointment, call us at (704) 343-6658 and we will let you know if we can accommodate your request.
                  </Typography>
                </div>
              </div>

              {
                type === 'boarding' && (
                  <div style={{ marginTop: 48 }}>
                    <CardHeader title="BOOKING TEXT BOX" style={{ paddingLeft: 0 }} />
                    <div className={classes.sharingWrapper}>
                      <Typography
                        style={{
                          color: '#1a1a35',
                          fontSize: 16,
                          fontWeight: '600'
                        }}>
                        Enable Booking Text Box
                      </Typography>
                      <Switch
                        checked={current.services.boarding.show_booking_text_box}
                        onChange={() => {
                          setCurrent({
                            ...current,
                            services: {
                              ...current.services,
                              boarding: {
                                ...current.services.boarding,
                                show_booking_text_box: !current.services.boarding.show_booking_text_box
                              }
                            }
                          })
                        }}
                        name="sharingKennels"
                        icon={
                          <div className={classes.thumb}>
                            <Icon className="far fa-times" />
                          </div>
                        }
                        checkedIcon={
                          <div className={classes.thumb}>
                            <Icon className="far fa-check" />
                          </div>
                        }
                        classes={{
                          root: classes.switchRoot,
                          switchBase: classes.switchBase,
                          thumb: classes.thumb,
                          track: classes.track,
                          checked: classes.checked
                        }}
                      />
                    </div>
                    <TextField
                      variant="filled"
                      style={{
                        width: 600,
                        minWidth: 600,
                        marginRight: 24,
                        marginTop: 24
                      }}
                      multiline={true}
                      label="Booking Text Box"
                      required
                      value={current.services.boarding.new_booking_message}
                      onChange={(e) => {
                        setCurrent({
                          ...current,
                          services: {
                            ...current.services,
                            [type]: {
                              ...current.services[type],
                              new_booking_message: e.target.value
                            }
                          }
                        })
                      }
                      } />

                    <div style={{ marginTop: 24 }}>
                      <Typography variant="h5" className={classes.header}>
                        PREVIEW BOOKING TEXT
                      </Typography>
                      <div className={classes.purple}>
                        <Typography variant="body2" className={classes.purpleText}>
                         {current.services.boarding.new_booking_message}
                        </Typography>
                      </div>
                    </div>
                  </div>
                )
              }
            </CardContent>
          </Card>

          {
            type === 'boarding' && (
              <Card style={{ maxWidth: '1245px' }}>
                <CardHeader title="Holiday Deposit" />
                <CardContent>
                  <Typography variant="h5" className={classes.header3}>
                    Nightly Holiday Deposit Rate
                  </Typography>
                  <Typography variant="body2" style={{ fontWeight: '600', fontSize: 14, color: '#1A1A35' }}>
                    When clients book a boarding appointment over a holiday, then they will be <br />charged this rate per dog per overnight as a deposit on the appointment.
                  </Typography>
                  <TextField
                    variant="filled"
                    style={{
                      width: 200,
                      minWidth: 200,
                      marginRight: 24,
                      marginTop: 16
                    }}
                    label="Price"
                    value={
                      formatNumsToDollars(onlyNumbers(current?.services[type].deposit_rate))
                    }
                    onChange={(e) => {
                      setCurrent({
                        ...current,
                        services: {
                          ...current.services,
                          [type]: {
                            ...current.services[type],
                            deposit_rate: e.target.value
                          }
                        }
                      })
                    }
                    } />
                </CardContent>
              </Card>
            )
          }



          {isSaveShown ? (
            <AppBar position="fixed" color="primary" className={classes.appBar}>
              <Toolbar>
                <Container maxWidth="md">
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={loading}
                    style={{ marginRight: '8px' }}
                    onClick={() => saveSelectedFacility()}>
                    Save Changes
                  </Button>
                  <Button variant="outlined" color="secondary" onClick={clearChanges}>
                    Cancel
                  </Button>
                </Container>
              </Toolbar>
            </AppBar>
          ) : null}
        </Container>
      ) : null}
      {loading ? <LoadingOverlay /> : null}
    </div>
  )
}

export default FacilityBasicInfo
